import { siteInfo } from "@/mocks/manga";

const groupNav = [
  { label: "年代翻看", href: "#eras" },
  { label: "经典老番", href: "#hot" },
  { label: "绝版资源", href: "#rare" },
  { label: "考古专题", href: "#archive" },
];

const helpNav = [
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
  { label: "求补旧坑", href: "#request" },
  { label: "联系站长", href: "#request" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#hero" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg text-background-50">
                073
              </span>
              <span className="font-heading text-lg text-foreground-950">{siteInfo.name}</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {siteInfo.name}专注老漫画补档与经典老番考古，收录童年漫画、怀旧漫与绝版资源，
              按年代与题材整理，帮每一位漫迷找回记忆里的老漫画。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-wechat-line", "ri-chat-smile-3-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#request"
                  aria-label="社交媒体链接"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-950">浏览内容</h4>
            <ul className="mt-4 space-y-2.5">
              {groupNav.map((n) => (
                <li key={n.label}>
                  <a
                    href={n.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-950">帮助支持</h4>
            <ul className="mt-4 space-y-2.5">
              {helpNav.map((n) => (
                <li key={n.label}>
                  <a
                    href={n.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500">合作 / 投稿：{siteInfo.email}</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 老漫画补档 · 经典老番考古</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500"></i>
            为记忆里的童年漫画存档
          </p>
        </div>
      </div>
    </footer>
  );
}